import React, { useEffect, useState, Fragment } from 'react';
import {
  Button,
  Container,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  Select,
  TextField,
  Typography
} from '@material-ui/core';
import useForm from "react-hook-form";
import ShareIcon from "../../images/share-icon.svg";
import ListaArquivos from "../shared/arquivos/index";
import Mascara from "../shared/mascaras";
import Mensagem from "../shared/message";
import ReCAPTCHA from "react-google-recaptcha";
import mensagemSucesso from "../../images/sucesso.png";
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { criarTicket, getItilCategories, guardarSessionGlpi, uploadFile, deleteFile, associarFiles } from "../../services/ChamadoService";
import { getUrlApi } from '../../services/Api';
import load from "../../images/loading.gif";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

const Loading = (props) => {
  const { isLoading } = props;
  return isLoading ?
    <div style={{ zIndex: 99, background: 'rgba(255,255,255,0.5)', position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <img src={load} alt='icone de carregando'/>
    </div> : <Fragment />
};

const FaleConosco = () => {

  const isMobile = useMediaQuery('(min-width:600px)');

  const [loading, setLoading] = useState(false);

  const hostName = window.location.hostname === "sacnacional.sebrae.com.br";

  const listarEstados = [
    { 'uf': 'Acre', 'id': hostName ? 90 : 88 },
    { 'uf': 'Alagoas', 'id': hostName ? 91 : 89 },
    { 'uf': 'Amapá', 'id': hostName ? 93 : 90 },
    { 'uf': 'Amazonas', 'id': hostName ? 92 : 91 },
    { 'uf': 'Bahia', 'id': hostName ? 94 : 92 },
    { 'uf': 'Ceará', 'id': hostName ? 95 : 93 },
    { 'uf': 'Distrito Federal', 'id': hostName ? 96 : 87 },
    { 'uf': 'Espirito Santo', 'id': hostName ? 97 : 94 },
    { 'uf': 'Goiás', 'id': hostName ? 98 : 95 },
    { 'uf': 'Maranhão', 'id': hostName ? 99 : 96 },
    { 'uf': 'Mato Grosso', 'id': hostName ? 102 : 97 },
    { 'uf': 'Mato Grosso do Sul', 'id': hostName ? 101 : 98 },
    { 'uf': 'Minas Gerais', 'id': hostName ? 100 : 99 },
    { 'uf': 'Pará', 'id': hostName ? 103 : 100 },
    { 'uf': 'Paraíba', 'id': hostName ? 104 : 101 },
    { 'uf': 'Paraná', 'id': hostName ? 106 : 102 },
    { 'uf': 'Pernambuco', 'id': hostName ? 105 : 103 },
    { 'uf': 'Piauí', 'id': hostName ? 87 : 104 },
    { 'uf': 'Rio de Janeiro', 'id': hostName ? 107 : 105 },
    { 'uf': 'Rio Grande do Norte', 'id': hostName ? 108 : 106 },
    { 'uf': 'Rio Grande do Sul', 'id': hostName ? 111 : 107 },
    { 'uf': 'Rondônia', 'id': hostName ? 109 : 108 },
    { 'uf': 'Roraima', 'id': hostName ? 110 : 109 },
    { 'uf': 'Santa Catarina', 'id': hostName ? 112 : 110 },
    { 'uf': 'São Paulo', 'id': hostName ? 114 : 111 },
    { 'uf': 'Sergipe', 'id': hostName ? 113 : 112 },
    { 'uf': 'Tocantins', 'id': hostName ? 115 : 113 },
  ].map((uf) => <option key={uf['id']} value={uf['id']} >{uf['uf']}</option>);

  const extensoesPermitidas = [
    'JPG', 'JPEG', 'PNG', 'PDF', 'TIFF', 'ZIP'
  ];

  const goBack = (event) => {
    event.preventDefault();
    event.stopPropagation();
    window.history.back();
  }

  // let listarMotivo = [];
  const [useMotivos, setMotivos] = useState([]);
  const [useAssuntos, setAssuntos] = useState([]);
  const [recaptchaKey, setRecaptchaKey] = useState();
  const [recaptchaValid, setRecaptchaValid] = useState(false);
  const [politicaPrivacidade, setPoliticaPrivacidade] = useState(false);

  useEffect(() => {
    getUrlApi("REACT_APP_RECAPTCHA_SITE_KEY").then((key) => {
      setRecaptchaKey(key);
    })
    guardarSessionGlpi().then((data) => {
      getItilCategories().then((res) => {
        let listaMotivos = [];
        const dados = res.data.data || [];
        dados.forEach(assunto => {
          const { 1: nome, 2: id } = assunto;
          listaMotivos.push({ nome, id });
        })
        setMotivos(listaMotivos);
      });
    }).catch((error) => {
      console.log(error)
    });
  }, []);

  const getAssuntos = (event) => {
    setLoading(true);
    const objId = event.target.value;
    const idPai = JSON.parse(objId);
    setAssuntos([]);
    if (idPai.id) {
      getItilCategories(idPai.id).then((res) => {
        let listaAssunto = [];
        const dados = res.data.data || [];
        dados.forEach(assunto => {
          const { 14: nome, 2: id } = assunto;
          listaAssunto.push({ nome, id });
        })
        setAssuntos(listaAssunto);
        setLoading(false);
      })
    }
  }

  const [enviado, setEnviado] = useState(false);
  const [ticket, setTicket] = useState();

  const [arquivos, setArquivo] = useState([]);
  const [mensagemArquivo, setMensagemArquivo] = useState({
    open: false,
    mensagem: ''
  });
  const mensagemPadrao = "Escolher arquivo";
  const [campoArquivo, setCampoArquivo] = useState(mensagemPadrao);

  const [estadoVerificado, setEStadoVerificado] = useState('');
  const updateEstado = (e) => setEStadoVerificado(e.target.value);

  const validateFileSize = (size) => size <= (1024 * 1024 * 2);
  const validateType = (type) => {
    const extension = type.split("/");
    if (extension.length <= 1) {
      return false;
    }
    const last = extension.length - 1;
    const fileExtension = extension[last];
    if (!extensoesPermitidas.some((ele) => ele === fileExtension.toUpperCase())) {
      return false;
    }
    return extension[last];
  }

  const adicionarArquivo = async (event) => {
    setMensagemArquivo({ ...mensagemArquivo, open: false });
    const tempFiles = event.target.files || [];
    if (tempFiles.length === 0) {
      setMensagemArquivo({ ...mensagemArquivo, open: true, mensagem: 'Erro ao adicionar arquivo' });
      return;
    }
    const currentFile = tempFiles[0];
    if (!validateFileSize(currentFile.size)) {
      setMensagemArquivo({ ...mensagemArquivo, open: true, mensagem: 'Tamanho acima do permitido' });
      setCampoArquivo(currentFile.name)
      return;
    };
    if (!validateType(currentFile.type)) {
      setMensagemArquivo({ ...mensagemArquivo, open: true, mensagem: 'Formato não permitido' });
      setCampoArquivo(currentFile.name)
      return;
    };
    if (!estadoVerificado) {
      setMensagemArquivo({ ...mensagemArquivo, open: true, mensagem: 'Primeiro selecione um estado' });
      return;
    }
    setLoading(true);
    uploadFile(currentFile, estadoVerificado).then((data) => {
      currentFile.id = data.data.id;
      const listaArquivos = [];
      arquivos.map((fil) => listaArquivos.push(fil));
      listaArquivos.push(currentFile);
      setMensagemArquivo({ ...mensagemArquivo, open: false });
      setArquivo(listaArquivos);
      setLoading(false);
    }).catch((error) => {
      console.log(error);
      setMensagemArquivo({ ...mensagemArquivo, open: true, mensagem: 'Não foi possível adicionar o arquivo. Verifique sua conexão de internet' });
      setCampoArquivo(currentFile.name);
      setLoading(false);
      return;
    });
  };

  const removerArquivo = (index, id) => {
    setLoading(true);
    const tempFiles = [];
    arquivos.map((item) => tempFiles.push(item));
    deleteFile(id).then((data) => {
      try {
        tempFiles.splice(index, 1);
        setArquivo(tempFiles);
        setLoading(false);
      } catch (error) {
        setMensagemArquivo({ ...mensagemArquivo, open: true, mensagem: 'Não é possível concluir ação' });
        setLoading(false);
      };
    }).catch((error) => {
      console.log(error);
      setMensagemArquivo({ ...mensagemArquivo, open: true, mensagem: 'Não é possível concluir ação' });
      setLoading(false);
    });
  }


  // forms hooks
  const { handleSubmit, register, errors } = useForm();

  const onSubmit = (values) => {
    setLoading(true);
    const {
      nome, cpf, email, nascimento, telefone, estado, motivo, assunto, mensagem, canal
    } = values;

    const assuntoObj = JSON.parse(assunto);
    const motivoObj = JSON.parse(motivo);
    const { nome: titulo, id } = assuntoObj;
    const conteudo = "Nome: " + nome + " \n" +
      "CPF: " + cpf + "\n" +
      'Data de nascimento: ' + nascimento + "\n" +
      "Telefone: " + telefone + "\n" +
      "Motivo: " + motivoObj.nome + "\n" +
      "E-mail: " + email + "\n" +
      (canal ? "Canal de entrada: " + canal + "\n" : "") +
      "Mensagem: " + mensagem + "\n";
    criarTicket(conteudo, cpf + ' - '+titulo, email, estado, id).then((ticketId) => {
      if (arquivos.length > 0) {
        associarFiles(ticketId, arquivos).then((data) => {
          setTicket(ticketId);
          setEnviado(true);
          setLoading(false);
        }).catch((error) => {
          console.error(error);
          setLoading(false);
        });
      } else {
        setTicket(ticketId);
        setEnviado(true);
        setLoading(false);
      }
    }).catch((error) => {
      console.error(error);
      setLoading(false);
    });
  }

  const checkForError = (error, index, whole) => error;

  const avaliableErrors = [errors.nome, errors.cpf, errors.email, errors.nascimento, errors.telefone, errors.estado, errors.assunto, errors.mensagem];

  return (
    <form style={{ marginTop: 29, paddingBottom: 24 }} onSubmit={handleSubmit(onSubmit)}>
      <Loading isLoading={loading} />
      <Container maxWidth={enviado ? "lg" : "md"} style={isMobile ? { padding: '0 56px' } : {}} >
        {<div style={{ display: 'flex', color: '#0F438A', fontSize: 16 }}>
          <Typography style={{ cursor: 'pointer' }}> <a href="https://www.sebrae.com.br/sites/PortalSebrae" style={{ textDecoration: 'none', textTransform: 'none', color: 'inherit' }}>Página inicial</a>  </Typography>
          <Typography style={{ margin: '0 6px' }}> </Typography>
          <Typography style={{ cursor: 'pointer' }}><a href="https://www.sebrae.com.br/sites/PortalSebrae/faleconosco" style={{ textDecoration: 'none', textTransform: 'none', color: 'inherit' }}>Fale conosco</a></Typography>
        </div>}
        {enviado && <Typography style={{ display: 'flex', color: '#0F438A', fontSize: 16 }}><a href="https://www.sebrae.com.br/sites/PortalSebrae/faleconosco" style={{ textDecoration: 'none', textTransform: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}> <ChevronLeftIcon /> Voltar  </a></Typography>}
        <Typography style={{ fontWeight: 'bold', color: '#005eb8', fontSize: '1.5rem', marginBottom: 24 }}>Atendimento ao cliente</Typography>
        {enviado ?
          <>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', }}>
              <div style={{ flexGrow: 1, marginBottom: 20 }}>
                <Mensagem />
                <div style={{ marginTop: 16 }}>
                  <p style={{ color: '#617385', fontSize: 27, fontWeight: 'bold', margin: 0 }}>Seu protocolo de atendimento é {ticket}.</p>
                  <p style={{ color: '#617385', fontSize: 19, margin: 0, marginTop: 12 }}>{"Não precisa anotar, enviamos uma cópia para o seu e-mail."}</p>
                  <a href="https://www.sebrae.com.br/sites/PortalSebrae" style={{ fontFamily: 'Lato', cursor: 'pointer', textDecoration: 'none', backgroundColor: '#fff', border: '1px solid #005EB8', boxSizing: 'border-box', borderRadius: 4, boxShadow: '0px 2px 4px rgba(20, 46, 82, 0.2)', color: '#005EB8', padding: '8px 12px', display: 'block', width: 200, marginTop: 32 }}>Voltar para página inicial</a>
                </div>
              </div>
              <img src={mensagemSucesso} style={{ maxWidth: 406, width: '100%' }} alt='icone de sucesso'/>
            </div>
          </>
          :
          <>
            <Typography style={{ color: '#394D60', fontSize: 16, marginBottom: 24 }}>Preencha os campos para enviar o formulário:</Typography>
            {avaliableErrors.some(checkForError) && <Mensagem tipo="error" />}
            <Grid container spacing={3} style={{ marginTop: 16 }}>
              <Grid item lg={12} xs={12}>
                <TextField
                  name="nome"
                  error={errors.nome}
                  inputRef={register({
                    required: "Informe seu nome completo",
                  })}
                  label="Nome Completo"
                  helperText={errors.nome && errors.nome.message}
                ></TextField>
              </Grid>

              <Grid item sm={4} md={4} xs={12} >
                <TextField
                  label="CPF"
                  name="cpf"
                  error={errors.cpf}
                  InputProps={{
                    inputComponent: Mascara.cpf,
                  }}
                  inputRef={register({
                    required: "Informe o CPF válido",
                    pattern: {
                      value: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/,
                      message: 'Informe o CPF válido'
                    }
                  })}
                  helperText={errors.cpf && errors.cpf.message}
                ></TextField>
              </Grid>

              <Grid item sm={8} md={8} xs={12}>
                <TextField
                  label="E-mail"
                  type="mail"
                  name="email"
                  error={errors.email}
                  inputRef={register({
                    required: "Informe um e-mail válido. exemplo nome@email.com",
                    pattern: {
                      value: /^\S+@\S+\.\S+$/,
                      message: 'Informe um e-mail válido. exemplo nome@email.com'
                    }
                  })}
                  helperText={errors.email && errors.email.message}
                ></TextField>
              </Grid>

              <Grid item sm={6} md={3} xs={12}>
                <TextField
                  label="Data de nascimento"
                  name="nascimento"
                  error={errors.nascimento}
                  InputProps={{
                    inputComponent: Mascara.data,
                  }}
                  inputRef={register({
                    required: "Informe uma data de nascimento válida. Exemplo: DD/MM/AAAA",
                    message: "Informe uma data de nascimento válida. Exemplo: DD/MM/AAAA",
                    validate: (value) => {
                      let campos = value.split("/");
                      let data = new Date(campos[1] + "/" + campos[0] + "/" + campos[2]);
                      return (!isNaN(data.getTime()) && campos[2].length === 4) || "Informe uma data de nascimento válida. Exemplo: DD/MM/AAAA";
                    }
                  })}
                  helperText={errors.nascimento && (errors.nascimento.message || errors.nascimento.validate)}
                ></TextField>
              </Grid>

              <Grid item md={4} sm={6} xs={12}>
                <TextField
                  label="Telefone"
                  name="telefone"
                  error={errors.telefone}
                  placeholder="DDD + Número"
                  InputProps={{
                    inputComponent: Mascara.telefone,
                  }}
                  inputRef={register({
                    required: "Informe um telefone válido. Exemplo: (00) 0000-0000",
                    pattern: {
                      value: /^\(\d\d\) \d\d\d\d-\d\d\d\d\d|\(\d\d\) \d\d\d\d-\d\d\d\d$/,
                      message: "Informe um telefone válido. Exemplo: (00) 0000-0000",
                    }
                  })}
                  helperText={errors.telefone && errors.telefone.message}
                ></TextField>
              </Grid>

              <Grid item sm={5} md={5} xs={12}>
                <FormControl error={errors.estado}>
                  <InputLabel>Estado</InputLabel>
                  <Select native
                    onChange={updateEstado}
                    disabled={arquivos.length > 0}
                    inputProps={{
                      name: "estado",
                    }}
                    inputRef={register({
                      required: "Selecione o estado",
                    })}
                  >
                    <option value="">Selecione</option>
                    {listarEstados}
                  </Select>
                  {errors.estado && <FormHelperText>{errors.estado.message}</FormHelperText>}
                </FormControl>

              </Grid>

              <Grid item sm={7} md={4} xs={12}>
                <FormControl error={errors.motivo}>
                  <InputLabel>Motivo do contato</InputLabel>
                  <Select native
                    defaultValue={''}
                    onChange={getAssuntos}
                    inputProps={{
                      name: "motivo",
                    }}
                    inputRef={register({
                      required: "Selecione o motivo",
                    })}
                  >
                    <option disabled hidden value="">Selecione</option>
                    {useMotivos.map(({ nome, id }, index) => (
                      <option key={index} value={JSON.stringify({ nome, id })}>{nome}</option>
                    ))}
                  </Select>
                  {errors.motivo && <FormHelperText>{errors.motivo.message}</FormHelperText>}
                </FormControl>

              </Grid>

              <Grid item sm={12} md={8} xs={12}>
                <FormControl error={errors.assunto}>
                  <InputLabel>Assunto</InputLabel>
                  <Select native
                    inputProps={{
                      name: "assunto",
                      error: errors.assunto,
                      disabled: useAssuntos.length === 0
                    }}
                    inputRef={register({
                      required: "Selecione o assunto",
                    })}
                  >
                    <option value="">Selecione</option>
                    {useAssuntos.map(({ nome, id }, index) => (
                      <option key={index} value={JSON.stringify({ nome, id })}>{nome}</option>
                    ))}
                  </Select>
                  {errors.assunto && <FormHelperText>{errors.assunto.message}</FormHelperText>}
                </FormControl>

              </Grid>


              <Grid item xs={12}>
                <TextField
                  error={errors.mensagem}
                  label="Mensagem"
                  name="mensagem"
                  placeholder="Descreva em detalhes como podemos te ajudar"
                  inputRef={register({
                    required: "Escreva a mensagem",
                  })}
                  multiline
                  helperText={errors.mensagem && errors.mensagem.message}
                  rows="4">

                </TextField>
              </Grid>
              <Grid item xs={12}>
                <FormControl error={true}>
                  <InputLabel>Arquivo <span style={{ color: '#B6BFC8', fontStyle: 'italic', marginBottom: 12 }}>(Opcional)</span></InputLabel>
                  <div>
                    <label style={{ minHeight: 40, display: 'flex', position: 'relative', marginTop: 18, }}>
                      <input onChange={adicionarArquivo} style={{ display: 'none' }} type="file" id="myfile" name="myfile" />
                      <span style={{ border: mensagemArquivo.open ? '1px solid #B22400' : '1px solid #B6BFC8', borderRadius: 4, padding: '8px 12px', width: '100%', color: mensagemArquivo.open ? '#B22400' : '#8B99A7' }}>{campoArquivo}</span>
                      <span style={{ position: 'absolute', top: 0, right: 0, height: '100%', backgroundColor: '#005EB8', padding: '8px 12px', borderRadius: 4, display: 'flex', alignItems: 'center', color: '#fff', boxShadow: '0px 2px 4px rgba(20, 46, 82, 0.2)', boxSizing: 'border-box' }}> <img style={{ marginRight: 4 }} src={ShareIcon} alt='icone de anexar'/>Anexar</span>
                    </label>
                  </div>
                  {mensagemArquivo.open && <FormHelperText>{mensagemArquivo.mensagem}</FormHelperText>}
                  <span style={{ color: mensagemArquivo.open ? '#B22400' : '#617385', fontStyle: 'italic', fontSize: 13 }}>Formatos permitidos JPG, PNG, PDF, ZIP e TIFF. Tamanho máximo de 2MB</span>
                </FormControl>
              </Grid>
              {arquivos.length > 0 && <Grid item xs={12}>
                <ListaArquivos onRemove={removerArquivo} arquivos={arquivos} />
              </Grid>}
              {recaptchaKey && (
                <Grid item xs={12}>
                  <span style={{ fontSize: 11, color: '#617385', maxWidth: 302, display: 'block' }}>Por razões de segurança, por favor responda à questão abaixo para enviar o formulário:</span>
                  <ReCAPTCHA
                    sitekey={recaptchaKey}
                    onChange={(e) => setRecaptchaValid(true)}
                    onExpired={(e) => setRecaptchaValid(false)}
                    onErrored={(e) => setRecaptchaValid(false)}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <label>
                  <input 
                    type="checkbox" 
                    id="politicaPrivacidade" 
                    defaultChecked={politicaPrivacidade}
                    onClick={(e) => setPoliticaPrivacidade((value) => !value)}
                  />
                  Estou de acordo com a <a target="_blank" rel="noopener noreferrer" href="https://minio-cpe.sebrae.com.br/documento/politica-privacidade.pdf">política de Privacidade</a>
                </label>
              </Grid>
            </Grid>
            <div style={{ paddingTop: 24, display: 'flex' }}>
              <div style={{ marginRight: 12 }}>
                <Button disabled={!recaptchaValid || !politicaPrivacidade} type="submit" variant="contained">Enviar formulário</Button>
              </div>
              <div style={{ marginRight: 12 }}>
                <Button onClick={goBack} type="submit" variant="outlined">cancelar</Button>
              </div>
            </div> </>}
      </Container>
    </form>
  )
}

export default FaleConosco;
